import { FetchBaseQueryMeta } from "@reduxjs/toolkit/dist/query";
import api, { getBackstageURL, PaginationResponse } from "services/api";

export interface Log {
  id: number;
  date: string;
  thread: string;
  level: string;
  logger: string;
  message: string;
  exception: string;
  user: string | null;
}

const extendedApi = api.injectEndpoints({
  endpoints: (build) => ({
    logs: build.query<
      PaginationResponse<Log>,
      {
        start: string;
        end: string;
        page?: number;
        perPage?: number;
        search?: string;
        sort?: string;
      }
    >({
      query: ({ page = 1, perPage = 50, start, end, search, sort }) => ({
        url: getBackstageURL("/logs"),
        params: { page, perPage, start, end, search, sort },
      }),
      providesTags: (result, error, arg) =>
        result
          ? [
              ...result.items.map(({ id }) => ({
                type: "Log" as const,
                id,
              })),
              "Log",
            ]
          : ["Log"],
      transformResponse: (res: Log[], meta: FetchBaseQueryMeta) => {
        const headerTotalCount = +meta.response?.headers.get("total-count");

        return {
          totalCount: Number.isNaN(headerTotalCount) ? 0 : headerTotalCount,
          items: res ?? [],
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useLogsQuery, useLazyLogsQuery } = extendedApi;
